import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, ArrowRight } from 'lucide-react';

// Reusable 2A Protection Plan teaser. Links to /repair-protection-plan.
export const ProtectionPlanNotice = ({ className = '', testId = 'protection-plan-notice' }) => {
  return (
    <Link
      to="/repair-protection-plan"
      data-testid={testId}
      className={`group flex items-center justify-center gap-2.5 px-4 py-2.5 rounded-xl bg-gradient-to-r from-amber-400/15 via-amber-300/10 to-orange-400/15 hover:from-amber-400/25 hover:via-amber-300/20 hover:to-orange-400/25 border border-amber-400/40 hover:border-amber-300/70 transition-all ${className}`}
    >
      <ShieldCheck className="w-4 h-4 sm:w-5 sm:h-5 text-amber-300 flex-shrink-0" />
      <span className="px-1.5 py-0.5 rounded-full bg-amber-400 text-slate-950 text-[9px] sm:text-[10px] font-black tracking-wider uppercase flex-shrink-0">New</span>
      <span className="text-amber-200 text-[11px] sm:text-sm font-semibold text-center">
        2A Protection Plan, 50% off your repair, covered for 6 months
      </span>
      <ArrowRight className="w-3.5 h-3.5 text-amber-300 group-hover:translate-x-0.5 transition-transform flex-shrink-0" />
    </Link>
  );
};

export default ProtectionPlanNotice;
